// Module
var code = "<span id=\"update-banner\"><span translate=\"go-banner_goreact-update-available\"></span>&nbsp; <a class=\"tertiary-btn goreact-btn\" href ng-click=\"$window.location.reload()\" translate=\"go-banner_goreact-refresh\"></a></span>";
// Exports
module.exports = code;